import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { PATHS } from "../routes/paths";
import {
  getCidadePorSlug,
  subscribeCidadeUpdates,
} from "../services/cidades";
import { getImageUrl } from "../utils/media";
import ApoieButton from "../components/ApoieButton/ApoieButton";
import RegionalHubHero from "../components/RegionalHub/Hero/Hero";
import TituloNucleo from "../components/RegionalHub/TituloNucleo/TituloNucleo";
import Slideshow from "../components/RegionalHub/Slideshow/Slideshow";
import Apresentacao from "../components/RegionalHub/Apresentacao/Apresentacao";
import NucleoIndicadores from "../components/RegionalHub/Indicadores/Indicadores";
import Parcerias from "../components/RegionalHub/Parcerias/Parcerias";
import Equipe from "../components/QuemSomos/Equipe/Equipe";
import ComoAjudar from "../components/RegionalHub/ComoAjudar/ComoAjudar";
import {
  MOCK_QUEM_MANTEM_TEXTO,
  MOCK_HISTORIA_FALLBACK,
  MOCK_COMO_AJUDAR_TEXTO,
  MOCK_PARCEIROS,
  MOCK_EQUIPE,
  ESTADO_FALLBACK,
} from "./RegionalHub.mocks";
import lavrasHeroUrl from "../assets/images/lavras-hero.jpg";
import lavrasBrandFlowerUrl from "../assets/images/lavras-brand-flower.svg";
import lavrasBrand7GeracoesUrl from "../assets/images/lavras-brand-7geracoes.svg";
import lavrasBrandProserUrl from "../assets/images/lavras-brand-proser.svg";
import lavrasPartnerSabaraUrl from "../assets/images/lavras-partner-sabara.png";
import lavrasPartnerProserUrl from "../assets/images/lavras-partner-proser.png";
import lavrasTeamGiseleUrl from "../assets/images/lavras-team-gisele.png";
import lavrasIndicatorsBgUrl from "../assets/images/lavras-indicators-bg.png";
import sabaraHeroUrl from "../assets/images/sabara-hero.jpg";
import sabaraSlideUrl from "../assets/images/sabara-slide.png";
import sabaraIndicatorsBgUrl from "../assets/images/sabara-indicators-bg.png";
import macaiaHeroUrl from "../assets/images/macaia-hero.jpg";
import macaiaSlideUrl from "../assets/images/macaia-slide.jpg";
import macaiaIndicatorsBgUrl from "../assets/images/macaia-indicators-bg.png";
import "./RegionalHub.css";
import { DEFAULT_CITY_INDICATORS } from "../utils/cityIndicators";

const STATUS = {
  LOADING: "loading",
  READY: "ready",
  NOT_FOUND: "not-found",
  ERROR: "error",
};

export const LAVRAS_INDICATORS = DEFAULT_CITY_INDICATORS;

export const LAVRAS_PARTNERS = [
  {
    name: "Prefeitura Municipal de Sabará",
    logoUrl: lavrasPartnerSabaraUrl,
  },
  {
    name: "Instituto ProSer",
    logoUrl: lavrasPartnerProserUrl,
  },
];

export const LAVRAS_HISTORY_TEXT =
  "";

export const LAVRAS_MAINTAINED_TEXT =
  "";

export const LAVRAS_HELP_TEXT =
  "";

export const LAVRAS_CONTACT = {
  email: "",
  phone: "(31) x xxxx-xxxx",
};

export const LAVRAS_TEAM = Array.from({ length: 8 }, (_, index) => ({
  _id: `lavras-gisele-${index}`,
  name: "Gisele Vilas Boas",
  role: "Coordenadora Social",
  photoUrl: lavrasTeamGiseleUrl,
}));

const PROSER_BRAND_ASSETS = {
  flower: lavrasBrandFlowerUrl,
  titleLogo: lavrasBrand7GeracoesUrl,
  subLogo: lavrasBrandProserUrl,
};

export const STATIC_REGIONAL_HUBS = {
  lavras: {
    title: "Núcleo 7 Geração - ProSer",
    city: "Lavras",
    state: "Minas Gerais",
    heroImageUrl: lavrasHeroUrl,
    heroAlt: "Crianças do núcleo ProSer em Lavras",
    heroPosition: "center 22%",
    indicatorsImageUrl: lavrasIndicatorsBgUrl,
    slideshow: [
      {
        url: lavrasHeroUrl,
        alt: "Crianças do núcleo ProSer em Lavras",
        focalPoint: "center 34%",
      },
    ],
  },
  sabara: {
    title: "Núcleo 7 Geração - ProSer",
    city: "Sabará",
    state: "Minas Gerais",
    heroImageUrl: sabaraHeroUrl,
    heroAlt: "Jovens sentados no núcleo ProSer em Sabará",
    heroPosition: "center 30%",
    indicatorsImageUrl: sabaraIndicatorsBgUrl,
    slideshow: [
      {
        url: sabaraSlideUrl,
        alt: "Atividade com crianças no núcleo ProSer em Sabará",
        focalPoint: "center center",
      },
    ],
  },
  macaia: {
    title: "Núcleo 7 Geração - ProSer",
    city: "Macaia",
    state: "Minas Gerais",
    heroImageUrl: macaiaHeroUrl,
    heroAlt: "Pátio do núcleo ProSer em Macaia",
    heroPosition: "center 58%",
    indicatorsImageUrl: macaiaIndicatorsBgUrl,
    slideshow: [
      {
        url: macaiaSlideUrl,
        alt: "Crianças do núcleo ProSer em Macaia",
        focalPoint: "center center",
      },
    ],
  },
  sarzedo: {
    title: "Núcleo 7 Geração - ProSer",
    city: "Sarzedo",
    state: "Minas Gerais",
    heroImageUrl: sabaraHeroUrl,
    heroAlt: "Jovens do núcleo ProSer em Sarzedo",
    heroPosition: "center 30%",
    indicatorsImageUrl: sabaraIndicatorsBgUrl,
    slideshow: [
      {
        url: sabaraSlideUrl,
        alt: "Atividade com crianças no núcleo ProSer em Sarzedo",
        focalPoint: "center center",
      },
    ],
  },
  varginha: {
    title: "Núcleo 7 Geração - ProSer",
    city: "Varginha",
    state: "Minas Gerais",
    heroImageUrl: macaiaHeroUrl,
    heroAlt: "Núcleo ProSer em Varginha",
    heroPosition: "center 58%",
    indicatorsImageUrl: macaiaIndicatorsBgUrl,
    slideshow: [
      {
        url: macaiaSlideUrl,
        alt: "Crianças do núcleo ProSer em Varginha",
        focalPoint: "center center",
      },
    ],
  },
};

export function getStaticRegionalHub(slug) {
  const normalizedSlug = slug?.toLowerCase();
  if (["macaiba", "macara"].includes(normalizedSlug)) {
    return STATIC_REGIONAL_HUBS.macaia;
  }
  return STATIC_REGIONAL_HUBS[normalizedSlug];
}

function getApiSlugs(slug) {
  const normalizedSlug = slug?.toLowerCase();
  if (["macaia", "macara"].includes(normalizedSlug)) {
    return [normalizedSlug, "macaiba"];
  }
  return [normalizedSlug];
}

if (typeof window !== "undefined") {
  Object.values(STATIC_REGIONAL_HUBS).forEach((hub) => {
    [hub.heroImageUrl, hub.indicatorsImageUrl, hub.slideshow?.[0]?.url]
      .filter(Boolean)
      .forEach((src) => {
        const img = new Image();
        img.src = src;
      });
  });
}

export default function RegionalHub() {
  const { slug } = useParams();
  const staticHub = getStaticRegionalHub(slug);
  const [request, setRequest] = useState({
    slug: null,
    data: null,
    status: STATUS.LOADING,
  });
  const currentRequest = request.slug === slug ? request : null;
  const data = currentRequest?.data || null;
  const status = currentRequest?.status ||
    (staticHub ? STATUS.READY : STATUS.LOADING);

  useEffect(() => {
    let active = true;
    const fallbackHub = getStaticRegionalHub(slug);

    setRequest({
      slug,
      data: null,
      status: fallbackHub ? STATUS.READY : STATUS.LOADING,
    });

    const loadCity = async () => {
      let lastError;

      for (const apiSlug of getApiSlugs(slug)) {
        try {
          const response = await getCidadePorSlug(apiSlug);
          if (active) {
            setRequest({ slug, data: response, status: STATUS.READY });
          }
          return;
        } catch (error) {
          lastError = error;
          if (error?.response?.status !== 404) break;
        }
      }

      if (!active) return;

      if (lastError?.response?.status === 404) {
        setRequest({ slug, data: null, status: STATUS.NOT_FOUND });
        return;
      }

      if (!fallbackHub) {
        setRequest({ slug, data: null, status: STATUS.ERROR });
      }
    };

    loadCity();
    return () => {
      active = false;
    };
  }, [slug]);

  useEffect(() =>
    subscribeCidadeUpdates((update) => {
      if (
        !update?.cidade ||
        !getApiSlugs(slug).includes(update.slug)
      ) {
        return;
      }

      setRequest({ slug, data: update.cidade, status: STATUS.READY });
    }),
  [slug]);

  if (status === STATUS.LOADING) {
    return (
      <div className="page-shell page-shell--centered">
        <div className="page-shell__content">
          <p className="page-shell__description">Carregando núcleo...</p>
        </div>
      </div>
    );
  }

  if (status === STATUS.NOT_FOUND) {
    return (
      <div className="page-shell page-shell--centered">
        <div className="page-shell__content">
          <h1 className="page-shell__title">Cidade não encontrada</h1>
          <p className="page-shell__description">
            Não encontramos nenhum núcleo com o endereço "{slug}". Ele pode ter
            sido removido ou o link pode estar incorreto.
          </p>
          <Link to={PATHS.ondeEstamos} className="regional-hub__voltar">
            Ver todas as cidades
          </Link>
        </div>
      </div>
    );
  }

  if (status === STATUS.ERROR) {
    return (
      <div className="page-shell page-shell--centered">
        <div className="page-shell__content">
          <h1 className="page-shell__title">
            Não foi possível carregar esta página
          </h1>
          <p className="page-shell__description">
            Ocorreu um erro ao buscar os dados deste núcleo. Tente novamente em
            instantes.
          </p>
          <Link to={PATHS.ondeEstamos} className="regional-hub__voltar">
            Ver todas as cidades
          </Link>
        </div>
      </div>
    );
  }

  const heroSlide = data?.slideshow?.find(
    (slide) => !/youtube\.com|youtu\.be|instagram\.com/i.test(slide?.url || ""),
  );
  const heroImageUrl = staticHub?.heroImageUrl || getImageUrl(heroSlide);
  const heroLogoUrl = getImageUrl(
    data?.heroLogo || data?.brandLogo || data?.logo,
  );
  const tituloNucleo =
    data?.presentation?.title || staticHub?.title || data?.name;
  const fallbackSlides = staticHub?.slideshow || [];

  const historiaParagrafos = [data?.presentation?.description].filter(Boolean);

  const secoesInstitucionais = [
    {
      title: "História e Atuação",
      paragraphs: historiaParagrafos.length
        ? historiaParagrafos
        : [staticHub ? LAVRAS_HISTORY_TEXT : MOCK_HISTORIA_FALLBACK],
    },
    {
      title: "Quem mantém este núcleo?",
      paragraphs: [
        data?.description ||
          (staticHub ? LAVRAS_MAINTAINED_TEXT : MOCK_QUEM_MANTEM_TEXTO),
      ],
    },
  ];

  const indicadoresImagem = getImageUrl(data?.indicatorsImage);

  const contatoReal = data?.contact_info || {};
  const temContatoReal = Boolean(
    contatoReal.address ||
      contatoReal.phone ||
      contatoReal.whatsapp ||
      contatoReal.email ||
      contatoReal.website,
  );

  const parceriasReais = (data?.partnerships || [])
    .filter((partnership) => partnership?.name || partnership?.logoUrl)
    .map((partnership) => ({
      name: partnership.name,
      logoUrl: getImageUrl(partnership.logoUrl),
      redirectUrl: partnership.redirectUrl,
    }));

  const equipeReal = (data?.team || []).map((membro) => ({
    _id: membro._id,
    name: membro.name,
    role: membro.role,
    photo: getImageUrl(membro.photoUrl || membro.photo),
  }));
  const equipeFallback = (staticHub ? LAVRAS_TEAM : MOCK_EQUIPE).map(
    (membro) => ({
      ...membro,
      photo: getImageUrl(membro.photoUrl || membro.photo),
    }),
  );
  const membrosEquipe = data?.teamConfigured ? equipeReal : equipeFallback;

  return (
    <div className="regional-hub-page">
      <RegionalHubHero
        key={`${slug}-${heroImageUrl || "placeholder"}`}
        imageUrl={heroImageUrl}
        imageAlt={
          staticHub?.heroAlt || heroSlide?.alt || data?.name || data?.city || ""
        }
        logoUrl={staticHub ? undefined : heroLogoUrl}
        imagePosition={staticHub?.heroPosition}
        brandAssets={staticHub ? PROSER_BRAND_ASSETS : undefined}
      />

      <ApoieButton />

      <TituloNucleo
        nome={tituloNucleo}
        cidade={data?.city || staticHub?.city}
        estado={data ? data.state ?? "" : staticHub?.state || ESTADO_FALLBACK}
      />

      <Slideshow
        slides={data?.slideshow}
        fallbackSlides={fallbackSlides}
      />

      <Apresentacao sections={secoesInstitucionais} />

      <NucleoIndicadores
        indicators={data?.indicators}
        fallbackIndicators={staticHub ? LAVRAS_INDICATORS : []}
        imageUrl={indicadoresImagem || staticHub?.indicatorsImageUrl}
        showOverlay={!(indicadoresImagem || staticHub?.indicatorsImageUrl)}
      />

      <Parcerias
        partners={
          parceriasReais.length
            ? parceriasReais
            : staticHub
              ? LAVRAS_PARTNERS
              : MOCK_PARCEIROS
        }
      />

      <Equipe team={{ title: "Equipe", members: membrosEquipe }} />

      <ComoAjudar
        text={
          data?.helpText ||
          (staticHub ? LAVRAS_HELP_TEXT : MOCK_COMO_AJUDAR_TEXTO)
        }
        contact={temContatoReal ? data.contact_info : staticHub ? LAVRAS_CONTACT : data?.contact_info}
      />
    </div>
  );
}
